export default __webpack_public_path__ + "static/media/lightningBoltLBIcon.369baa20.svg";